// Copyright (c) 2016 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import CheckboxFilterControlled from '../../../../shared/components/facets/checkbox-filter/controlled';
import CheckboxWithSearchFilterControlled from '../../../../shared/components/facets/checkbox-with-search-filter/controlled';
import FacetFooter from '../../../../shared/components/facets/facet-footer';
import Facets from '../../state/facets';
import FacetsDateRangePickerControlled from '../../../../shared/components/facets/date-range-picker/controlled';
import RequestTypeFacet from '../../../shared/components/request-type-facet';
import ShippingInstruction from '../../../shared/components/shipping-instruction';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';
import {getDateFormat} from '../../../../shared/services/get-date-format';
import {isDealerFacetInvalid} from '../../../../shared/services/facets';

const handleDealerFilterInput = actions =>
        text =>
            actions.updateDealerAccountFacetInput(text);

const handleDealerAccountsFacetChange = actions =>
    (dealerAccount, isSelected) =>
        actions.updateFacetsDealer(dealerAccount, isSelected);

const handleDealersAccountsFacetToggle = actions =>
    () =>
        actions.toggleFacetsDealers();

const handleStatusFacetChange = actions =>
    (status, isSelected) =>
        actions.updateFacetsStatus(status, isSelected);

const handleStatusesFacetChange = actions =>
    () =>
        actions.updateFacetsStatuses();

const handleDatePickerChange = actions =>
        requestedDates =>
            actions.updateFacetsDateRange(requestedDates);

class PartRequestsSearchAside extends Component {

    state = {
        dateRangePickerExpanded: false,
        dealerLocationExpanded: false,
        requestStatusExpanded: false,
        requestTypeExpanded: false
    };

    componentWillMount() {

        this.props.actions.initializeFacets();

    }

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.dateRangePickerExpanded || this.state.requestTypeExpanded || this.state.dealerLocationExpanded || this.state.requestStatusExpanded;

    render() {

        return (
            <aside>
                <section className='part-requests-search-facets'>
                    <CheckboxWithSearchFilterControlled
                        initialState={createHashMap(this.props.facets.dealerAccountsFacet.selectedDealers, 'account')}
                        isExpanded={this.state.dealerLocationExpanded}
                        itemDisplayAttributes={[]}
                        list={addCollectionLabels(this.props.facets.dealerAccountsFacet.displayedDealers)}
                        minNumberOfItems={4}
                        onCheckboxListChange={handleDealerAccountsFacetChange(this.props.actions)}
                        onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                        onInputChange={handleDealerFilterInput(this.props.actions)}
                        onToggleAll={handleDealersAccountsFacetToggle(this.props.actions)}
                        searchInput={this.props.facets.dealerAccountsFacet.searchInput}
                        searchPlaceholder='DEALER_LOCATION_FILTER'
                        title='DEALER_LOCATIONS'
                        valueKey='account'
                    />
                    <CheckboxFilterControlled
                        displayKey='value'
                        initialState={createHashMap(this.props.facets.statusFacet.selectedStatuses, 'key')}
                        isExpanded={this.state.requestStatusExpanded}
                        itemDisplayAttributes={[]}
                        list={addCollectionLabels(this.props.facets.statusFacet.allowedStatuses, 'value')}
                        minNumberOfItems={4}
                        onChange={handleStatusFacetChange(this.props.actions)}
                        onClick={this.onAccordionToggle.bind(this, 'requestStatusExpanded')}
                        onToggleAll={handleStatusesFacetChange(this.props.actions)}
                        title='PART_REQUEST_STATUS'
                        valueKey='key'
                    />
                    <RequestTypeFacet
                        actions={this.props.actions}
                        facets={this.props.facets}
                        isExpanded={this.state.requestTypeExpanded}
                        onClick={this.onAccordionToggle.bind(this, 'requestTypeExpanded')}
                        title='REQUEST_TYPE'
                    />
                    <FacetsDateRangePickerControlled
                        dateFormat={getDateFormat(this.context.user.settings.general.dateFormat.key)}
                        dateRange={this.props.facets.requestDateFacet.dateRange}
                        isExpanded={this.state.dateRangePickerExpanded}
                        onChange={handleDatePickerChange(this.props.actions)}
                        onClick={this.onAccordionToggle.bind(this, 'dateRangePickerExpanded')}
                        title='REQUESTED'
                    />
                    {this.anyFacetsOpen() ?
                        <FacetFooter
                            disabled={isDealerFacetInvalid(this.props.facets.dealerAccountsFacet)}
                            onApply={this.props.actions.applyFacets}
                            onReset={this.props.actions.resetFacets}
                        /> : null}
                </section>
                <section className='shipping-instructions'>
                    <ShippingInstruction/>
                </section>
            </aside>
        );

    }

}

PartRequestsSearchAside.displayName = 'PartRequestsSearchAside';
PartRequestsSearchAside.propTypes = {
    actions: PropTypes.object.isRequired,
    facets: PropTypes.instanceOf(Facets).isRequired
};
PartRequestsSearchAside.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default PartRequestsSearchAside;



// WEBPACK FOOTER //
// ./src/part-requests/search/components/part-requests-search-aside/part-requests-search-aside.js